module.exports = __webpack_public_path__ + "static/media/rolnikon.ef8da24e.jpg";